// extracted by mini-css-extract-plugin
export default {"corporate-form":"corporate-form_Iw7zt"};